<template lang="pug">
  l-map(ref="map" :center="center" :zoom="zoom" :options="mapOptions" v-on="$listeners")
    slot
</template>

<script>
/* global L */
/* eslint prefer-const:0 */
import { LMap } from 'vue2-leaflet'
import "leaflet/dist/leaflet.css"
import "mapbox-gl/dist/mapbox-gl.css"
import 'mapbox-gl-leaflet'

export default {
  components: {
    LMap
  },

  props: {
    center: {
      type: [Array, Object],
      required: true
    },

    zoomDesktop: {
      type: Number,
      required: true
    },

    zoomMobile: {
      type: Number,
      required: true
    },

    options: {
      type: Object,
      default: () => ({})
    },

    disableInteractions: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    zoom () {
      if (window.matchMedia("(min-width: 720px)").matches) {
        return this.zoomDesktop
      }

      return this.zoomMobile
    },

    mapOptions () {
      const options = { ...this.options }

      if (this.disableInteractions) {
        options.zoomControl = false
        options.doubleClickZoom = false
        options.dragging = false
        options.keyboard = false
        options.scrollWheelZoom = false
        options.boxZoom = false
      }

      return options
    }
  },

  mounted () {
    L.mapboxGL({
      style: 'https://api.maptiler.com/maps/36f5c30a-3013-44f1-bdb7-1ca1ddc60ec3/style.json?key=aBTF6H2w1tLiJOG9OS7j',
      accessToken: 'no-token'
    }).addTo(this.$refs.map.mapObject)
  },

  methods: {
    fitBounds (bounds) { this.$refs.map.fitBounds(bounds) },
    closePopup () { this.$refs.map.mapObject.closePopup() }
  }
}
</script>
